<template>
  <div class="eventsBookingContainer" :class="range.duration===0?'singleDay':''" :style="{overflow: 'hidden'}">
    <div>
    <div class="title">
      <div>{{$route.meta.title}}</div>
      <Select1 :defaultValue="event" @input="event=$event" :width="'665px'">
        <option v-for="(ev, i) in events" :key="`ev-${i}`" :value="ev._id">{{ev?.name}}</option>
      </Select1>
      <button class="addTeam" :style="{marginLeft: 'auto'}" @click="fnAdd"></button>
      <button v-if="bookings&&bookings.length>0" class="printTable" @click="actPrint=true"></button>
    </div>
    <div class="subtitle">
      <div>狀態篩選</div>
      <Select1 :defaultValue="status" @input="status=$event" :width="'200px'">
        <option :value="null">所有狀態</option>
          <option value="預約中">預約中</option>
          <option value="通知付訂">通知付訂</option>
          <option value="已付訂">已付訂</option>
          <option value="已報到">已報到</option>
          <option value="已取消">已取消</option>
      </Select1>
      <input type="text" class="search" v-model="searchText" placeholder="搜尋">
      <DateSelect :defaultValue="range" @input="range=$event"/>
      <div v-if="range.duration===0" :style="{fontSize: '20px', fontWeight: '700', color:'var(--color-pri)', paddingLeft: '20px'}">{{range.start}}</div>
      <!--
      <input type="radio" class="top" v-model="daterange" value="今日預約" before="今日" after="預約" :style="{marginLeft: '13px'}">
      <input type="radio" class="top" v-model="daterange" value="明日預約" before="明日" after="預約">
      <input type="radio" class="top" v-model="daterange" value="全部預約" before="全部" after="預約">
      <input type="radio" class="top" v-model="daterange" value="自訂時間" before="自訂" after="時間" @click="rangeSelect=true">
      <div :style="{left: '945px'}" class="customDate" :class="daterange==='今日預約'||daterange==='明日預約'?'singleDay':''" v-if="daterange==='自訂時間'&&rangeSelect===true">
        <vue-ctk-date-time-picker :range="true" v-model="range"
        :only-date="true"
        :color="'var(--color-pri)'"
        :no-label="true"
        :input-size="'sm'"
        :label="'選取時間範圍'"
        :format="'YYYY-MM-DD'"
        :formatted="'YYYY-MM-DD'"
        />
          <button @click="rangeSelect=false"></button>
      </div> -->
    </div>
    <div :style="{overflowY: 'auto', maxHeight: 'calc(100vh - 150px)'}">
    <Table :rows="bookings">
      <template slot="slot_head">
        <th :style="{textAlign: 'start', width: '132px'}">狀態</th>
        <th :style="{width: '105px'}">編號</th>
        <th :style="{textAlign: 'start', width: '145px'}" v-if="range.duration!==0">報名日期</th>
        <th :style="{width: '105px'}">時段</th>
        <th :style="{textAlign: 'start', width: '8em'}">預約人</th>
        <th :style="{textAlign: 'start', width: '9em'}">聯絡電話</th>
        <th :style="{width: '6em'}">居住縣市</th>
        <th :style="{width: '6em', paddingLeft: '40px'}">成人</th>
        <th  :style="{width: '6em', paddingRight: '40px'}">孩童</th>
        <th :style="{textAlign: 'start', width: 'inherit'}">備註</th>
        <th></th>
      </template>
      <tr slot-scope="item" @click="setSelected(item.item)" :class="itemSelect?._id===item.item._id?'selected' : ''"  :style="{height: '100px', borderBottom: '1px solid var(--color-border)'}">
        <td :style="{textAlign: 'start'}">
          <div @mouseenter="extendthis" @mouseleave="closethis" class="status" :style="{backgroundColor: `var(--${item.item.status})`}">
            {{item.item.status}}
            <div class="statusBtns">
              <template v-for="sta in statusmap">
              <button :key="`sta-${sta}-${item.index}`" @click="updateStatus(item.item._id, sta)"
              v-if="sta!==item.item.status&&sta!=='已付訂'&&sta!=='通知付訂'" :style="{backgroundColor: `var(--${sta})`}">{{sta}}</button>
              <button :key="`sta-${sta}-${item.index}`" @click="updateStatus(item.item._id, sta)"
              v-else-if="sta!==item.item.status&&sta==='已付訂'&&(item.item.remitName||item.item.remit5code)" :style="{backgroundColor: `var(--${sta})`}">{{sta}}</button>
              </template>
            </div>
          </div>
        </td>
        <td>{{String.fromCharCode(65 + item.item.event?.session.indexOf(item.item?.session))}}{{item.item.field_sn[0].toString().padStart(3, '0')}}</td>
        <td :style="{textAlign: 'start',whiteSpace: 'nowrap'}" v-if="range.duration!==0">{{toDate(item.item.visitDate)}}</td>
        <td>{{item.item?.session}}</td>
        <td :style="{textAlign: 'start'}">{{item.item.field_name}}</td>
        <td :style="{textAlign: 'start'}">{{item.item.field_tel}}</td>
        <td>{{item.item.field_city}}</td>
        <td :style="{width: '105px', paddingLeft: '40px'}">
          <span :class="item.item.checkinNum&&item.item.checkinNum!==item.item.reserveNum?'lineThroungth':''">{{item.item.reserveNum}}</span>
          <span v-if="item.item.checkinNum&&item.item.checkinNum!==item.item.reserveNum"><br>{{item.item.checkinNum}}</span>
        </td>
        <td :style="{width: '105px', paddingRight: '40px'}">
          <span :class="item.item.checkinNumChild&&item.item.checkinNumChild!==item.item.reserveNumChild?'lineThroungth':''">{{item.item.reserveNumChild}}</span>
          <span v-if="item.item.checkinNumChild&&item.item.checkinNumChild!==item.item.reserveNumChild"><br>{{item.item.checkinNumChild}}</span>
        </td>
        <td :style="{textAlign: 'start'}">
          <div class="toolong" :style="{width: '340px', maxWidth: range.duration === 0 ? '320px' : '600px', whiteSpace:'nowrap'}">{{item.item.field_remark}}</div>
          <div v-if="item.item.remitAmount">{{
            item.item.remitTime?moment(item.item.remitTime).format('yyyy/MM/DD HH:mm'):''
          }} {{
          item.item.remitName||item.item.remit5code
          }} ${{
          item.item.remitAmount
          }}</div>
        </td>
        <td :style="{width: '80px'}" class="remarkTip">
          <svg v-if="item.item.field_remark" width="26" height="30" viewBox="0 0 26 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_247_1545)">
              <mask id="mask0_247_1545" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="26" height="30">
              <path d="M25.7021 0H0.00500488V30H25.7021V0Z" fill="white"/>
              </mask>
              <g mask="url(#mask0_247_1545)">
              <path d="M16.0581 21.3674H6.42925C5.83748 21.3674 5.35938 21.8455 5.35938 22.4373C5.35938 23.0291 5.83748 23.5072 6.42925 23.5072H16.0581C16.6499 23.5072 17.128 23.0291 17.128 22.4373C17.128 21.8455 16.6499 21.3674 16.0581 21.3674ZM6.42925 14.9482C5.83748 14.9482 5.35938 15.4263 5.35938 16.0181C5.35938 16.6098 5.83748 17.0879 6.42925 17.0879H19.2678C19.8595 17.0879 20.3376 16.6098 20.3376 16.0181C20.3376 15.4263 19.8595 14.9482 19.2678 14.9482H6.42925ZM6.42925 8.52893C5.83748 8.52893 5.35938 9.00703 5.35938 9.59881C5.35938 10.1906 5.83748 10.6687 6.42925 10.6687H19.2678C19.8595 10.6687 20.3376 10.1906 20.3376 9.59881C20.3376 9.00703 19.8595 8.52893 19.2678 8.52893H6.42925Z" fill="#E37878"/>
              </g>
              <mask id="mask1_247_1545" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="26" height="30">
              <path d="M25.7021 0H0.00500488V30H25.7021V0Z" fill="white"/>
              </mask>
              <g mask="url(#mask1_247_1545)">
              <path d="M23.5373 26.7503C23.5373 27.342 23.0592 27.8201 22.4674 27.8201H3.20963C2.61785 27.8201 2.13975 27.342 2.13975 26.7503V4.28287C2.13975 3.6911 2.61785 3.21299 3.20963 3.21299H6.41926V1.07324H3.20963C1.43765 1.07324 0 2.51089 0 4.28287V26.7503C0 28.5223 1.43765 29.9599 3.20963 29.9599H22.4674C24.2394 29.9599 25.677 28.5223 25.677 26.7503V4.28287C25.677 2.51089 24.2394 1.07324 22.4674 1.07324H19.2578V3.21299H22.4674C23.0592 3.21299 23.5373 3.6911 23.5373 4.28287V26.7503Z" fill="#E37878"/>
              </g>
              <path d="M18.1812 0.0032959H7.48578V4.2828H18.1812V0.0032959Z" fill="#E37878"/>
              </g>
              <defs>
              <clipPath id="clip0_247_1545">
              <rect width="25.7021" height="30" fill="white"/>
              </clipPath>
              </defs>
            </svg>
            <div>備註: <br>{{item.item.field_remark}}</div>
        </td>
      </tr>
    </Table>
    </div>
    </div>
    <div v-if="range.duration===0" class="singleDaySide">
      <div>
        <div v-html="daterange==='今日預約'?moment().format('yyyy-MM-DD'):moment().add(1, 'day').format('yyyy-MM-DD')"></div>
        <div>{{daterange==='今日預約'?Wd[moment().weekday()]:Wd[moment().add(1, 'day').weekday()]}}</div>
      </div>
      <div>
        <input type="radio" v-model="sessionSelect" v-for="(ses, s) in eventSelect?.session" :key="`ses-${s}`" :value="ses">
        <button v-if="sessionSelect&&sessionSelect!==''" class="cancelradiobtn" @click="sessionSelect=null"/>
      </div>
      <hr>
      <template>
        <ReserveBox :title="'線上預約人數'" :AD="reserveNum" :CH="reserveChild" :color="'#E37878'" :style="{backgroundColor: 'var(--color-infobox)'}"/>
        <ReserveBox :title="'已報到人數'" :style="{marginTop: '5px'}" :AD="sumCheckinNum" :CH="sumCheckinChild" />
        <ReserveBox v-if="sessionSelect"
        :AD="eventSelect.limitNum ? eventSelect.limitNum-sumCheckinNum : '不限'"
        :CH="eventSelect.limitNumChild ? eventSelect.limitNumChild-sumCheckinChild : '不限'"
        :title="'可開放候補人數'" :style="{marginTop: '5px'}"/>
      </template>
    </div>
    <template v-if="eventSelect">
      <InfoSlider :icon="'balloon'" :show="addTeam" @close="addTeam=false" label="新增活動預約" :width="481">
        <NewEventComp :style="{padding: '10px 32px', gap: '20px', display: 'flex', flexDirection: 'column', overflowY: 'auto'}" v-if="addTeam" :eventName="eventSelect?.name"
        :sessions="eventSelect?.session"
        :eventType="eventSelect.eventType"
        :eventId="event"
        :addTeam="addTeam" @close="addTeam=false" @new="getnew"
        />
      </InfoSlider>
      <InfoSlider :icon="'balloon'" :show="!!itemSelect" @close="itemSelect=null" label="活動資訊" :width="481" :printBtn="true" :btnText="'報到'" @printInfo="showCheckin(itemSelect._id)">
        <EditEventComp :style="{padding: '10px 32px', gap: '20px', display: 'flex', flexDirection: 'column', overflowY: 'auto'}" v-if="itemSelect"
        :sessions="eventSelect?.session"
        :eventType="eventSelect.eventType"
        :eventId="event"
        :item="itemSelect" @close="itemSelect=null" @updateItem="updateItem"
        />
        <button  @click="showCheckin(itemSelect._id)" class="headerbtn" slot="headerbtn">報到</button>
      </InfoSlider>
      <printTable v-show="false"
      :eventName="eventSelect?.name"
      :sessions="eventSelect?.session"
      :items="bookings"
      :print="actPrint" @printed="actPrint=false" :date="range.duration===0
      ? moment(range.start).format('yyyy/MM/DD') : range.duration===null
      ? moment().add(1, 'day').format('yyyy/MM/DD~') : `${range.start}~${range.end}`"/>
    </template>
    <Dialog v-if="scanedItem" :show="scanedItem" :height="533" :width="742" :label="'報到資訊'" @close="scanedItem=null">
      <div class="EventInfobox">
        <div>
          <div>預約編號: <span :style="{fontWeight: 700, fontSize: '28px'}">{{String.fromCharCode(65 + scanedItem.event?.session.indexOf(scanedItem?.session))}}{{scanedItem.field_sn[0].toString().padStart(3, '0')}}</span></div>
          <div>預約日期: <span :style="{fontSize: '24px', fontWeight: 700}">{{toDate(scanedItem.visitDate)}}</span></div>
          <div>預約時段: <span :style="{fontSize: '28px', fontWeight: 900, color: 'var(--color-checked)'}">{{scanedItem?.session}}</span></div>
          <div>預約姓名: <span :style="{fontSize: '36px', fontWeight: 900, color: '#6D6D6D'}">{{scanedItem.field_name}}</span></div>
          <div>報名人數: <span :style="{fontSize: '32px'}"><span :style="{color: '#E37878', fontSize: '32px', fontWeight: 900}">{{scanedItem.reserveNum}}</span>大 , <span :style="{color: '#E37878', fontSize: '32px', fontWeight: 900}">{{scanedItem.reserveNumChild}}</span>小</span></div>
          <div>預付訂金: <span :style="{fontSize: '28px', fontWeight: 700}">${{scanedItem.remitAmount||'0'}}</span></div>
        </div>
        <div>
          <div>變更人數</div>
          <NumInput @input="checkinNum=$event" :defaultValue="checkinNum" :title="'大人'" :style="{marginTop: '17px'}"/>
          <NumInput @input="checkinNumChild=$event" :defaultValue="checkinNumChild" :title="'小孩'" :color="'#E37878'" :style="{marginTop: '33px'}"/>
        </div>
      </div>
      <div class="dialogBtns">
        <button @click="scanedItem=null">取消</button>
        <button class="disabled" v-if="scanedItem.status==='已報到'" @click="scanedItem=null" >{{scanedItem.status}}</button>
        <button v-else @click="checkin">確認報到</button>
      </div>
    </Dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DateSelect from '../../components/dateRadio/DatesSelect.vue'
import NumInput from '../../components/input/num.vue'
import Dialog from '../../components/dialognoPadding2.vue'
import ReserveBox from '../../components/eventReserveBox.vue'
import InfoSlider from '../../components/infoSlider_v2.vue'
import EditEventComp from './booking/editEventBooking.vue'
import Table from '../../components/tables/t2.vue'
import printTable from './booking/printEvents.vue'
// import printingComp from './booking/printing.vue'
import NewEventComp from './booking/newEventBooking.vue'
import { getapi, postapi } from '../../store/fetch'
const wdy = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日']
export default {
  components: {
    NumInput,
    Dialog,
    printTable,
    // printingComp,
    EditEventComp,
    NewEventComp,
    InfoSlider,
    Table,
    ReserveBox,
    DateSelect
  },
  data () {
    return {
      scanedItem: null,
      sessionSelect: null,
      Wd: wdy,
      statusmap: [],
      openPreview: false,
      actPrint: false,
      range: {
        start: this.moment().format('YYYY-MM-DD'),
        end: this.moment().format('YYYY-MM-DD'),
        duration: 0
      },
      rangeSelect: false,
      daterange: '今日預約',
      searchText: null,
      status: null,
      event: null,
      events: [],
      eventSelect: null,
      addTeam: false,
      bookings: [],
      itemSelect: null,
      checkinNum: 0,
      checkinNumChild: 0
    }
  },
  computed: {
    ...mapState({
      scanid: state => state.scanid
    }),
    sumCheckinNum () {
      if (this.sessionSelect) {
        return this.reduce(this.bookings.filter(e => e?.session === this.sessionSelect).map(e => e.checkinNum))
      } else {
        return this.reduce(this.bookings.map(e => e.checkinNum))
      }
    },
    sumCheckinChild () {
      if (this.sessionSelect) {
        return this.reduce(this.bookings.filter(e => e?.session === this.sessionSelect).map(e => e.checkinNumChild))
      } else {
        return this.reduce(this.bookings.map(e => e.checkinNumChild))
      }
    },
    reserveNum () {
      if (this.sessionSelect) {
        return this.reduce(this.bookings.filter(e => e?.session === this.sessionSelect).map(e => e.reserveNum))
      } else {
        return this.reduce(this.bookings.map(e => e.reserveNum))
      }
    },
    reserveChild () {
      if (this.sessionSelect) {
        return this.reduce(this.bookings.filter(e => e?.session === this.sessionSelect).map(e => e.reserveNumChild))
      } else {
        return this.reduce(this.bookings.map(e => e.reserveNumChild))
      }
    }
  },
  watch: {
    async scanid () {
      if (this.scanid && /^event/ig.test(this.scanid) && this.scanid.length === 29) {
        this.scanedItem = await getapi(`events/${this.scanid.replace('event', '')}`)
        this.checkinNum = this.scanedItem.reserveNum
        this.checkinNumChild = this.scanedItem.reserveNumChild
      }
    },
    status () {
      this.getEvents()
    },
    daterange () {
      this.getEvents()
    },
    range: {
      handler () {
        if (this.range.start && (this.range.end || this.range.duration === null)) {
          this.getEvents()
        }
      },
      deep: true
    },
    searchText () {
      this.getEvents()
    },
    async event () {
      if (this.event) {
        this.eventSelect = await getapi(`eventSetting/${this.event}`)
        this.sessionSelect = null
        this.getEvents()
      } else {
        this.eventSelect = null
        this.sessionSelect = null
      }
    }
  },
  async mounted () {
    this.statusmap = await getapi('selections/bookStatus')
    this.events = await getapi('eventSetting/list?' + new URLSearchParams({
      range: this.daterange
    }))
    this.event = this.events[0]._id
    this.getEvents()
    let text = ''
    setInterval(() => {
      if (this.scanid !== '' && this.scanid === text) {
        this.$store.commit('setScanID', '')
        // console.log('reset scanid-----')
      } else {
        text = this.scanid
      }
    }, 1000)
  },
  methods: {
    async showCheckin (id) {
      this.scanedItem = await getapi(`events/${id}`)
      this.checkinNum = this.scanedItem.reserveNum
      this.checkinNumChild = this.scanedItem.reserveNumChild
    },
    async checkin () {
      const r = await postapi(`events/${this.scanedItem._id}`, { status: '已報到', checkinNum: this.checkinNum, checkinNumChild: this.checkinNumChild, checkinTime: this.moment().toISOString() })
      if (r) {
        if (this.scanedItem.event._id === this.event) {
          this.getEvents()
        }
        this.scanedItem = null
      }
    },
    setSelected (item) {
      // this.scanedItem = item
      if (this.itemSelect && (item._id === this.itemSelect._id)) {
        this.itemSelect = null
      } else {
        this.itemSelect = item
      }
    },
    extendthis (ev) {
      const current = ev.target
      console.log([current.className, ev.target.className])
      if (current.className === 'status') {
        if (current.lastChild.style.display) {
          current.lastChild.style.display = null
        } else {
          current.lastChild.style.display = 'flex'
        }
      }
    },
    async updateStatus (_id, status) {
      const r = await postapi(`events/${_id}`, { status: status })
      if (r) {
        const index = this.bookings.map(e => e._id).indexOf(_id)
        this.bookings[index].status = r.status
        this.getEvents()
      }
    },
    closethis (ev) {
      const current = ev.target
      current.lastChild.style.display = null
    },
    updateItem (item) {
      this.getEvents()
      this.itemSelect = item
    },
    getnew (ev) {
      if (this.moment(ev.visitDate).isBetween(this.moment(this.range.start).startOf('day'), this.moment(this.range.end).endOf('day'))) {
        this.getEvents()
      } else {
        const start = this.moment(ev.visitDate).format('yyyy-MM-DD')
        this.range = { start, end: start }
      }
    },
    async getEvents () {
      const params = {
        event: this.event,
        status: this.status,
        search: this.searchText,
        start: this.moment(this.range.start).toISOString()
      }
      if (this.range.duration !== null) {
        params.end = this.moment(this.range.end).toISOString()
      }
      // switch (this.daterange) {
      //   case '今日預約':
      //     params.start = this.moment().startOf('day').toISOString()
      //     params.end = this.moment().endOf('day').toISOString()
      //     break
      //   case '明日預約':
      //     params.start = this.moment().add(1, 'day').startOf('day').toISOString()
      //     params.end = this.moment().add(1, 'day').endOf('day').toISOString()
      //     break
      //   case '全部預約':
      //     params.start = this.moment().startOf('day').toISOString()
      //     break
      //   case '自訂時間':
      //     params.start = this.moment(this.range.start).add(1, 'day').startOf('day').toISOString()
      //     params.end = this.moment(this.range.end).add(1, 'day').endOf('day').toISOString()
      //     break
      // }
      Object.keys(params).forEach(k => {
        if (!params[k]) {
          delete params[k]
        }
      })
      const value = await getapi('events?' + new URLSearchParams(params))
      this.bookings = [...value.filter(e => e.status !== '已取消'), ...value.filter(e => e.status === '已取消')]
    },
    fnAdd () {
      this.itemSelect = null
      this.addTeam = true
    }
  }
}
</script>
<style lang="scss">
.eventsBookingContainer {
  .toolong {
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }
  .word4icon {
    background-image: url(/balloon.svg);
    background-size: 40px;
  }
}
.eventbookingtable {
  .btnPrint {
    width: 48px;
    height: 48px;
    border: none;
    border-radius: 5px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    background-color: var(--color-checked);
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.25);
    box-sizing: border-box;
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 10px 0px;
  }
  .cubeStatus {
    width: 100px;
    height: 40px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    &.預約中 {
      background-color: var(--預約中);
      color: #FFFFFF;
    }
    &.已付訂 {
      background-color: var(--已付訂);
      color: #FFFFFF;
    }
    &.通知付訂 {
      background-color: var(--通知付訂);
      color: #FFFFFF;
    }
    &.已報到 {
      background-color: var(--已報到);
      color: #FFFFFF;
    }
    &.已取消 {
      background-color: var(--已取消);
      color: #FFFFFF;
    }
  }
  .vip, .vvip, .supervip {
    width: 30px;
    height: 30px;
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: contain;
    margin: auto;
  }
  .vip {
    background-image: url(/vip.svg);
  }
  .vvip {
    background-image: url(/vvip.svg);
  }
  .supervip {
    background-image: url(/supervip.svg);
  }
  &.table {
    border-collapse: collapse;
  }
  .thead {
    background-color: var(--color-infobox);
    height: 40px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 40px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
  }
  .tbody {
    overflow-y: auto;
  }
  .tr {
    height: 64px;
    border-bottom: 1px solid var(--color-border);
    line-height: 64px;
    &.selected {
      background-color: var(--color-infobox);
    }
  }
  .td {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
    padding-inline: 6px;
  }
  .th {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: #000000;
    padding-inline: 6px;
  }
}
</style>
<style lang="scss">
.customDate {
  .header-picker .pl-10 {
    display: none;
  }
  .field-input {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px!important;
    line-height: 36px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
  }
}
</style>
<style lang="scss" scoped>
.headerbtn {
  position: absolute;
  top: 53px;
  right: 17px;
  border: none;
  z-index: 91;
  width: 60px;
  height: 30px;
  background-color: var(--color-pri-letter);
  color: var(--color-pri);
  border-radius: 15px;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1em;
}
.lineThroungth {
  text-decoration: line-through;
}
.cancelradiobtn {
  width: 30px;
  height: 30px;
  margin-top: 6px;
  color: #FFFFFF;
  background-color: #CACACA;
  border: none;
  border-radius: 20px;
  margin-left: auto;
  background-image: url(/svg/btn/cross.svg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 14px;
}
.EventInfobox {
  height: 340px;
  margin-block: 33px 35px;
  display: grid;
  grid-template-columns: 1fr 300px;
  &>div {
    &:nth-child(1) {
      border-right: 1px solid #AAAAAA;
      text-align: start;
      padding-left: 54px;
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      letter-spacing: 0.1em;
      display: flex;
      flex-direction: column;
      gap: 10px;
      &>div {
        height: fit-content;
        display: flex;
        align-items: flex-end;
        color: #6D6D6D;
        &>span {
          margin-left: 10px;
        }
      }
    }
    &:nth-child(2) {
      display: flex;
      flex-direction: column;
      &>div:nth-child(1) {
        color: var(--color-checked);
        font-weight: 500;
        font-size: 20px;
        line-height: 150%;
        letter-spacing: 0.1em;
      }
    }

  }
}
.dialogBtns {
  position: sticky;
  bottom: 0;
  display: grid;
  width: 100%;
  grid-template-columns: 310px 432px;
  height: 70px;
  button {
    border: none;
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 150%;
    text-align: center;
    letter-spacing: 0.1em;
    &:nth-child(1) {
      background-color: #C4C4C4;
      color: #FFFFFF;
    }
    &:nth-child(2) {
      background-color: #E37878;
      color: #FFFFFF;
    }
    &.disabled {
      background-color: var(--color-完成);
    }
  }
}
.remarkTip {
  position: relative;
  z-index: 10;
  &>svg {
    z-index: 11;
  }
  &>div {
    display: none;
  }
  &>svg:hover+div {
    display: block;
    position: absolute;
    width: 416px;
    background-color: var(--color-checked);
    color: #FFFFFF;
    font-weight: 400;
    font-size: 20px;
    line-height: 170%;
    left: -451px;
    padding: 20px;
    border-radius: 10px;
    top: 80px;
    text-align: start;
    z-index: 100;
  }
}
* {
  box-sizing: border-box;
}
.singleDaySide {
  border-left: 1px solid;
  position: relative;
  &>div:nth-child(1) {
    height: 89px;
    background-color: var(--color-checked);
    color: #FFFFFF;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 29px;
    text-align: center;
    letter-spacing: 0.1em;
  }
  hr {
    position: absolute;
    top: 89px;
    left: 0;
    bottom: 0;
    width: 1px;
    background-color: var(--color-border);
    border: none;
    margin: 0;
  }
  &>div:nth-child(2) {
    padding: 27px 18px 16px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 10px;
    flex-wrap: wrap;
    input[type=radio] {
      box-sizing: border-box;
      font-style: normal;
      font-weight: 600;
      font-size: 18px;
      width: 87px;
      text-align: center;
      line-height: 21px;
      letter-spacing: 0.1em;
      color: var(--color-checked);
      padding: 10px 13.5px;
      border: 2px solid var(--color-checked);
      border-radius: 23px;
      height: 41px;
      line-height: 18px;
      box-sizing: border-box;
      appearance: none;
      margin: 0;
      &::before {
        content: attr(value);
      }
      &:checked {
        background-color: var(--color-checked);
        color: #FFFFFF;
      }
    }
  }
}
.subtitle {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: #F8F7F7;
  height: 60px;
  padding-inline: 77px;
  gap: 10px;
  position: relative;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.1em;
  color: #5E5E5E;
  select {
    box-sizing: border-box;
    width: 155px;
    height: 40px;
    border: 1px solid #C4C4C4;
    border-radius: 3px;
    text-indent: 12px;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: var(--color-checked);
  }
}
.eventsBookingContainer.singleDay {
  display: grid;
  grid-template-columns: 1fr 421px;
  &>div:nth-child(2) {
    border-left: 1px soild var(--color-border);
    height: 100vh;
  }
}
.status {
  display: inline-flex;
  width: 100px;
  height: 40px;
  border-radius: 20px;
  align-items: center;
  justify-content: center;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
}
.status {
  position: relative;
}
.statusBtns {
  display: none;
  position: absolute;
  width: fit-content;
  background-color: transparent;
  left: 100px;
  top: -10px;
  bottom: -10px;
  height: 60px;
  border-radius: 3px;
  align-items: center;
  padding-inline: 10px;
  gap: 15px;
  button {
    height: 40px;
    width: 100px;
    border-radius: 20px;
    border: none;
    align-items: center;
    justify-content: center;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    // -1px -1px 4px 4px rgba(0, 0, 0, 0.25)
  }
}
.customDate {
  display: flex;
  position: absolute;
  top: 44px;
  left: 1110px;
  width: 380px;
  height: 80px;
  box-shadow: 4px 0px 15px rgba(0, 0, 0, 0.25);
  margin-top: 10px;
  background-color: #FFFFFF;
  border-radius: 5px;
  z-index: 1;
  padding: 20px;
  box-sizing: border-box;
  button {
    height: 36px;
    width: 36px;
    border: none;
    &::before {
      content: '⤫';
      font-size: 24px;
    }
  }
}
.addTeam, .printTable {
  width: 150px;
  box-sizing: border-box;
  height: 50px;
  background: var(--color-checked);
  border-radius: 50px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  border:none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  gap: 3px;
  &::before {
  content: '';
  display: inline-block;
  background-repeat: no-repeat;
  background-position: center;
  }
}
.printTable {
  width: 110px;
}
.printTable::before {
  width: 29px;
  height: 29px;
  background-image: url(/print.svg);
}
.printTable::after {
  content: '列印';
}
.addTeam::before {
  width: 29px;
  height: 29px;
  background-image: url(/plus.svg);
}
.addTeam::after {
  content: '新增預約';
}
input[type=radio].top {
  width: 80px;
  height: 40px;
  background-color: var(--color-border);
  appearance: none;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: attr(before);
    font-family: Roboto;
    font-style: normal;
    font-weight: 900;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
  }
  &:checked {
    background-color: var(--color-checked);
  }
  &:hover {
    filter: contrast(.5);
  }
}
.search {
  width: 300px;
  height: 40px;
  box-sizing: border-box;
  background-image: url(/search.svg);
  background-position: calc(100% - 10px) 10px;
  background-repeat: no-repeat;
  border-radius: 3px;
  border: 1px solid #C4C4C4;
  text-indent: 12px;
  font-size: 18px;
  display: flex;
  align-items: center;
  &::placeholder {
    color: var(--color-border);
  }
}
.title {
  margin-inline: 20px;
  background-color: #FFF;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  &::before {
    content: '';
    display: inline-flex;
    width: 55px;
    height: 55px;
    mask-image: url(/events.svg);
    mask-repeat: no-repeat;
    mask-position: center;
    background-color: var(--color-pri);
  }
  height: 89px;
  display: flex;
  align-items: center;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  letter-spacing: 0.15em;
  color: var(--color-pri);
  gap: 10px;
  select {
    box-sizing: border-box;
    width: 155px;
    height: 40px;
    border: 1px solid #C4C4C4;
    border-radius: 3px;
    text-indent: 12px;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: var(--color-checked);
  }
}
</style>
